interface Props {
  onView: () => void;
}

export function ConfidentialBanner({ onView }: Props) {
  return (
    <div className="flex items-center justify-between gap-3 rounded-md border border-[hsl(var(--warn))]/40 bg-[hsl(var(--warn))]/10 px-3 py-1.5 text-[11px] text-[hsl(var(--warn))]">
      <div className="flex items-center gap-2">
        <span
          aria-hidden
          className="inline-block h-1.5 w-1.5 rounded-full bg-[hsl(var(--warn))]"
        />
        <span className="font-semibold uppercase tracking-[0.18em]">
          Confidential
        </span>
        <span className="text-foreground/80">
          Project Martin internal use only — do not share, screenshot, or
          redistribute.
        </span>
      </div>
      <button
        type="button"
        onClick={onView}
        className="font-medium text-[hsl(var(--warn))] underline-offset-2 hover:underline"
      >
        View notice
      </button>
    </div>
  );
}
